import { PageLayout, Content } from "aldoo-ra/Layouts"
import Navbar from "../Navbar"
import Footer from "../Footer"
import AldooStore from "aldoo-ra/Store"
import CookieConsent from "../CookieConsent"

export default function Site({ children }) {
  return (
    <PageLayout>
      <Navbar />
      <Content>{children}</Content>
      <Footer />
      {/* Mounts the store instance (cart/checkout overlays) — store.addToCart
          is a no-op proxy until this renders */}
      <AldooStore />
      <CookieConsent />
    </PageLayout>
  )
}